module.exports = __webpack_public_path__ + "static/img/photo-about_s.a6e694a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/small/photo-about_s.jpg
// module id = b2as
// module chunks = 1